









import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Inspiration, InspirationHotspotImage } from '@/models/Inspiration';
import ImageHotspots from '@/components/Inspiration/ImageHotspots.vue'; // './ImageHotspots.vue';

@Component({
    components: {
        ImageHotspots
    }
})
export default class ImageWithHotspots extends Vue {
    protected inspiration!: Inspiration;
    protected initialImage!: InspirationHotspotImage;

    constructor() {
        super();

        this.inspiration = JSON.parse(this.$attrs['data-inspiration']);

        let image = this.inspiration.images[0];
        this.initialImage = {
            image: image.image,
            entityIds: image.entityIds,
            imageLink: image.imageLink,
            imageMap: image.imageMap
        };

      //  console.log(this.inspiration);

        this.$attrs['data-inspiration'] = '';
    }
}
